import { render, staticRenderFns } from "./ClaseProgramada.vue?vue&type=template&id=65b3178e&scoped=true&"
import script from "./ClaseProgramada.vue?vue&type=script&lang=js&"
export * from "./ClaseProgramada.vue?vue&type=script&lang=js&"
import style0 from "./ClaseProgramada.vue?vue&type=style&index=0&id=65b3178e&prod&scoped=true&lang=css&"
import style1 from "../../../assets/styles/shared-modals.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3178e",
  null
  
)

export default component.exports